var map = {
	"./1.svg": "Vosd",
	"./2.svg": "wLME",
	"./3.svg": "2NUZ",
	"./4.svg": "gqSP",
	"./5.svg": "/PsK",
	"./6.svg": "mUI/",
	"./7.svg": "sLV6",
	"./in.svg": "pf6S",
	"./out.svg": "b8co",
	"./up.svg": "Kzgf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yVOG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details/match_line ^\.\/.*\.svg$
// module id = yVOG
// module chunks = 0